export const featuredBlog = [
  {
    title: "Why We Decoupled CKAN’s Frontend — And What We Gained with PortalJS",
    image: "https://www.portaljs.com/static/img/blog/2025-05-28-Why-we-decoupled-CKAN%E2%80%99s-frontend/image1.png",
    href: "https://www.portaljs.com/blog/why-we-decoupled-CKAN-frontend",
    description: "We explain why we chose to decouple CKAN’s frontend and how PortalJS made our data portal faster, more flexible, and easier to maintain. A practical look at SSG, serverless scaling, and modern dev workflows with CKAN.",
    authors: ['Yoana-Popova.jpg', 'Anuar-Ustayev.jpg'],
    created: "2025-05-28"
  },
  {
    title: "Why NASA — and Anyone Using CKAN — Should Consider a Decoupled Front-End with PortalJS",
    image: "https://www.portaljs.com/static/img/blog/2025-05-19-why-anyone-should-consider-decoupled-frontend/image2.webp",
    href: "https://www.portaljs.com/blog/why-NASA-and-anyone-using-CKAN-should-consider-a-decoupled-front-end-with-PortalJS",
    description: "NASA’s open data portal is powered by CKAN—but what if its user experience could match its scientific depth? This post explores how a decoupled frontend using PortalJS can transform performance, design flexibility, and scalability—without changing the backend. Learn how CKAN and PortalJS can work together to deliver a faster, smarter, and more user-friendly data experience.",
    authors: ['Anuar-Ustayev.jpg', 'Yoana-Popova.jpg'],
    created: "2025-05-19"
  },
  {
    title: "The New Look of PortalJS Cloud",
    image: "https://www.portaljs.com/static/img/blog/2025-04-01-the-new-look-of-portaljs-cloud/image14.webp",
    href: "https://www.portaljs.com/blog/the-new-look-of-portaljs-cloud",
    description: "Discover how the redesigned PortalJS Cloud helps you launch a modern, WCAG 2.1/2.2-compliant open data portal—fully responsive, customizable, and optimized for lightning-fast search and data sharing. Built for governments, non-profits, academic institutions, and private organizations, it's the easiest way to deploy a user-friendly data platform in minutes.",
    authors: ['William-Lima.jpg', 'Yoana-Popova.jpg'],
    created: "2025-04-01"
  },
]
